import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Avatar, Spinner} from '../widgets';
import {ProfileCard} from '../profile';
import {CommunityCard} from '../community';
import CouponCard from './activity-coupon-card/ActivityCouponCard';

import './ActivityCard.css';
import fetchJson from '../fetchJson';
import handleError from '../handleError';
import {connect} from 'react-redux';

class ActivityCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			expanded: false,
			cardProfile: null
		};

		this.toggleExpansion = () => this.setState({expanded: !this.state.expanded});
	}

	componentDidMount() {
		let currentUserUuid;

		if (this.props.session && this.props.session.current && this.props.session.current.user) {
			currentUserUuid = this.props.session.current.user.uuid;
		}

		if (this.props.providerCardUuid && this.props.cardType === 'UPDATE') {
			fetchJson(`/api/providers/${this.props.providerCardUuid}`).then(provider =>
				this.setState({cardProfile: provider})
			);
		} else if (this.props.commCardUuid && this.props.cardType === 'UPDATE') {
			fetchJson(`/api/community/${this.props.commCardUuid}`)
				.then(community => this.setState({cardProfile: community}))
				.catch(err => {
					// just fail silently
					this.setState({cardProfile: 'none'});
				});
		} else if (this.props.couponCardUuid && this.props.cardType === 'COUPON') {
			fetchJson(`/api/coupon/${this.props.couponCardUuid}?userUuid=${currentUserUuid}`)
				.then(coupon => {
					this.setState({cardProfile: coupon});
				})
				.catch(err => {
					// just fail silently
					this.setState({cardProfile: 'none'});
				});
		}
	}

	processTitle(title, provider, community) {
		const target = provider || community;
		return target.name + ' ' + title;
	}

	couponRedeemed = data => {};

	render() {
		const {
			title,
			content,
			cardType,
			providerCardUuid,
			commCardUuid,
			imageUrl,
			community,
			provider,
			profile,
			screenSize,
			session
		} = this.props;
		const {expanded, cardProfile} = this.state;
		const isLarge = content && content.length > 256;

		let showRedeemButton = true;

		// check if type is coupon and if that coupon is created by current logged in provider
		// then dont show redeem button
		if (cardProfile && cardType === 'COUPON') {
			if (cardProfile.created_by.uuid === session.current.provider.uuid) {
				showRedeemButton = false;
			}
		}

		return (
			<React.Fragment>
				{cardProfile && cardType !== 'COUPON' ? (
					<article className="ActivityCard">
						<header className="ActivityCard-Header">
							{provider && (
								<Link to={`/@${profile.uniqueName}`}>
									<Avatar backgroundImage={profile.avatarImage} size={'32px'} />
								</Link>
							)}
							<div>
								<h2>
									{provider || community ? this.processTitle(title, provider, community) : title}
								</h2>
								{/* {date && <span className="timeSince">{timeSince(new Date(date))}</span>} */}
							</div>
						</header>

						{content && (
							<div
								className={`ActivityCard-Body ${isLarge ? (expanded ? 'expanded' : '') : 'small'}`}>
								{content}
							</div>
						)}
						{content && isLarge && (
							<button className="ActivityCard-ExpandButton" onClick={this.toggleExpansion}>
								{isLarge && <span>{expanded ? 'Read less' : 'Read more'}</span>}
							</button>
						)}

						{/* Load provider of community cards */}
						{providerCardUuid &&
							(cardProfile ? <ProfileCard provider={cardProfile} /> : <Spinner />)}
						{commCardUuid &&
							(cardProfile ? (
								cardProfile !== 'none' && <CommunityCard community={cardProfile} />
							) : (
								<Spinner />
							))}

						{imageUrl && (
							<div className="ActivityCard-ImgDiv">
								<img className="ActivityCard-Image" src={`/api/image/${imageUrl}`} alt="" />
							</div>
						)}
					</article>
				) : cardProfile && cardType === 'COUPON' ? (
					<article className="ActivityCard">
						<CouponCard
							key={cardProfile.uuid}
							screenSize={screenSize}
							size="small"
							avatarImage={cardProfile.created_by.profile.avatarImage}
							firstname={cardProfile.created_by.user.firstname}
							lastname={cardProfile.created_by.user.lastname}
							businessName={cardProfile.created_by.user.businessName}
							couponUuid={cardProfile.uuid}
							code={cardProfile.code}
							productLink={cardProfile.productLink}
							description={cardProfile.description}
							expiryDate={cardProfile.expiryDate}
							showActions={false}
							couponCommunity={cardProfile.community}
							coupon={cardProfile}
							redirectLink={'/coupons/' + cardProfile.community.profile.uniqueName}
							providerProfileLink={'/@' + cardProfile.created_by.profile.uniqueName}
							canRedeem={!cardProfile.redeemed}
							onRedeem={this.couponRedeemed}
							options={[]}
							showRedeemButton={showRedeemButton}
						/>
					</article>
				) : null}
			</React.Fragment>
		);
	}
}

const mapStateToProps = state => {
	return {
		session: state.session,
		screenSize: state.ui.screenSize,
		sessionProvider: state.session && state.session.current
	};
};

export default connect(mapStateToProps)(ActivityCard);



// WEBPACK FOOTER //
// ./src/stream/ActivityCard.js